// @ts-nocheck
import React from 'react';
import PlanToolbar from './PlanToolbar';
import PlanGrid from './PlanGrid';
import ScenarioRail from './ScenarioRail';

export default function PlanScreen({ vm }: { vm: any }) {
	if (!vm.showPlan) {
		return null;
	}
	return (
		<>
			<PlanToolbar vm={vm} />
			<PlanGrid vm={vm} />
			<ScenarioRail vm={vm} />
		</>
	);
}
